<template lang="pug">
  section
    transition( name="description" )
      .container( v-show="!isPlaceSelected && !isPlaceLoading" )
        .description
          p.en Search place
          p.jp 場所を指定する
        
        .placeList( v-if="isPlaceList" )
          ul
            li( 
              v-for="(place, index) in placeListData", 
              :key="index",
              @click="onSelect(place)"
            )
              | {{ getPlaceData(place) }}
        input(
          v-model="address",
          placeholder="input",
          maxlength="32"
        )
        .menu
          .btn( @click="onSearch" ) 
            p Search!
          .btn.other( v-if="isGPUAvailable", @click="onSearch_GPS" ) 
            p Use GPS
        .log {{ message }}

    transition( name="description" )
      .container( v-show="isPlaceSelected" )
        .description
          p.en Will you be at this place when you achieve that Goal?
          p.jp この場所で達成する？
        .menu
          .btn( @click="onFix" ) 
            p YES!
          .btn.no( @click="onReset" ) 
            p NO!
</template>

<script>
export default {
  props: {
    placeList: Array,
    isPlaceSelected: Boolean,
    isPlaceLoading: Boolean
  },

  data() {
    return {
      address: "",
      isGPUAvailable: false,
      message: ""
    };
  },

  mounted() {
    this.message = "";
    if ("geolocation" in navigator) this.isGPUAvailable = true;
  },

  methods: {
    //------------------------------------
    //Event Handling Methods
    //------------------------------------
    onSearch() {
      this.message = "";
      this.$emit("onSearch", this.address);
    },

    onSearch_GPS() {
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.$emit("onSelect", {
            _attr: {
              lat: {
                _value: pos.coords.latitude
              },
              lon: {
                _value: pos.coords.longitude
              }
            }
          });

          this.message = "";
          this.$emit("onSearch_GPS");
        },
        error => {
          switch (error.code) {
            case 1:
              this.message = "Permission Denied";
              break;
            case 2:
              this.message = "Location unavailable";
              break;
            case 3:
              this.message = "Timeout";
              break;
            case 4:
              this.message = "Error";
              break;
          }

          this.isGPUAvailable = false;
        }
      );
    },

    onSelect(place) {
      this.message = "";
      this.$emit("onSelect", place);
    },

    onFix() {
      this.message = "";
      this.$emit("onFix");
    },

    onReset() {
      this.message = "";
      this.$emit("onReset");
    },

    //------------------------------------
    //Helper Methods
    //------------------------------------
    getPlaceData(place) {
      let list = place._attr.display_name._value.split(",");
      list.reverse();

      let text = list.toString();
      text = text.replace(/,/g, " ");
      text = text.replace(/;/g, " ");

      return text;
    }
  },

  computed: {
    isPlaceList() {
      if (this.placeList.length > 0) return true;
      else return false;
    },

    placeListData() {
      return this.placeList.slice(0, 5);
    }
  }
};
</script>

<style scoped lang="scss">
.placeList {
  width: 100%;
  margin-bottom: 20px;

  ul {
    overflow-y: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    height: 200px;
  }

  li {
    display: block;
    margin: 5px 0;
    padding: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.8);
    text-align: left;
    font-size: 1.4rem;
    line-height: 1.4;
    color: #000;
    cursor: pointer;
    cursor: hand;

    &:hover {
      background: rgb(192, 192, 192);
    }
  }
}

.log {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 1rem;
}

@media screen and (min-width: 1080px) {
  .placeList {
    ul {
      height: auto;
    }
  }
}
</style>
